import { getAdditionalUserInfo, getRedirectResult } from "firebase/auth";
import { History, Location } from "history";

import { Dispatch, GetState } from "common/types";

import { getFirebaseAuth } from "services/firebase/auth";
import { getProviderName } from "services/firebase/auth/ssoProvider";

import { getRegion, signInStart } from "seneca-common/features/user/state";

import { makeInternalRedirectState } from "features/common/routing/InternalRedirectOnlyRoute";
import { makeSignUpUserDetailsLink } from "features/sign-up/common-routes/links";
import {
  makeInternalLink,
  pathEndings
} from "features/sign-up/global-sign-up-modal/utils";

import { proceedUserSignIn, proceedUserSignUp } from "./utils";

export default function signInWithProviderWithRedirect(
  location: Location<any>,
  history: History
) {
  const onSignUpSuccess = () => {
    history.push(
      makeInternalRedirectState({
        pathname: makeSignUpUserDetailsLink("/sign-up"),
        state: location.state
      } as any)
    );
  };

  return async function (dispatch: Dispatch, getState: GetState) {
    getRedirectResult(getFirebaseAuth())
      .then(async response => {
        if (response) {
          const userInfo = getAdditionalUserInfo(response);
          if (userInfo) {
            const providerName = getProviderName(userInfo.providerId!);

            dispatch(signInStart());

            const region = getRegion(getState())!;

            if (userInfo!.isNewUser) {
              await dispatch(
                proceedUserSignUp({
                  response,
                  region,
                  providerName,
                  onSignUpSuccess
                })
              );
            } else {
              await dispatch(
                proceedUserSignIn({
                  region,
                  providerName
                })
              );
            }
          }
        }
      })
      .catch(err => {
        if (err.code === "auth/account-exists-with-different-credential") {
          history.push(
            makeInternalRedirectState({
              pathname: makeInternalLink(pathEndings.confirmPassword),
              state: {
                ...location.state,
                auth: {
                  credential: err.credential.toJSON(),
                  email: err.email
                }
              }
            } as any)
          );
        }
      });
  };
}
